export const UI = {
  colors: {
    primary: '#16a34a',
    primaryDark: '#15803d',
    text: '#1f2937',
    muted: '#6b7280',
    border: '#e5e7eb',
    bg: '#f9fafb',
    card: '#ffffff',
    danger: '#dc2626',
    warning: '#f59e0b',
    info: '#2563eb',
  },
  font: {
    heading: "'Playfair Display', serif",
    body: "'Poppins', sans-serif",
  },
  radius: {
    md: 12,
    lg: 16,
    xl: 20,
    pill: 9999,
  },
  shadow: {
    sm: '0 2px 12px rgba(0,0,0,0.07)',
    md: '0 8px 30px rgba(0,0,0,0.12)',
  },
};

export const ui = {
  page: {
    minHeight: '100vh',
    backgroundColor: UI.colors.bg,
  },
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '24px 20px',
  },
  card: {
    backgroundColor: UI.colors.card,
    border: `1px solid ${UI.colors.border}`,
    borderRadius: UI.radius.lg,
    boxShadow: UI.shadow.sm,
  },
  cardBody: {
    padding: 24,
  },
  h1: {
    fontFamily: UI.font.heading,
    fontSize: 32,
    fontWeight: 900,
    lineHeight: 1.1,
    color: UI.colors.text,
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    color: UI.colors.muted,
    marginTop: 8,
    marginBottom: 0,
  },
};

export function buttonStyle(variant = 'primary') {
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '10px 16px',
    borderRadius: 12,
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.1,
    textDecoration: 'none',
    cursor: 'pointer',
    userSelect: 'none',
    border: '1px solid transparent',
    backgroundColor: 'transparent',
    color: UI.colors.text,
  };

  if (variant === 'primary') {
    return {
      ...base,
      backgroundColor: UI.colors.primary,
      borderColor: UI.colors.primary,
      color: '#ffffff',
      boxShadow: '0 2px 10px rgba(22,163,74,0.25)',
    };
  }

  if (variant === 'danger') {
    return {
      ...base,
      backgroundColor: UI.colors.danger,
      borderColor: UI.colors.danger,
      color: '#ffffff',
    };
  }

  if (variant === 'outline') {
    return {
      ...base,
      borderColor: UI.colors.border,
      backgroundColor: '#ffffff',
      color: UI.colors.text,
    };
  }

  if (variant === 'ghost') {
    return {
      ...base,
      borderColor: UI.colors.border,
      backgroundColor: 'transparent',
      color: UI.colors.text,
    };
  }

  return base;
}

export const fieldStyles = {
  label: {
    display: 'block',
    fontSize: 12,
    fontWeight: 700,
    color: UI.colors.text,
    marginBottom: 6,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: 12,
    border: `1.5px solid ${UI.colors.border}`,
    outline: 'none',
    backgroundColor: '#ffffff',
    fontSize: 14,
    color: UI.colors.text,
  },
  help: {
    marginTop: 6,
    fontSize: 12,
    color: UI.colors.muted,
  },
  error: {
    marginTop: 6,
    fontSize: 12,
    color: UI.colors.danger,
    fontWeight: 600,
  },
};

